import { KettleSteamIcon } from './KettleSteamIcon';

/**
 * author: Michael Irigoyen
 * id B976C4B0-D50C-49ED-B072-CD8E8A38A4AF
 * name kettle-steam
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-steam.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const TeaKettleSteamIcon = KettleSteamIcon;
export default TeaKettleSteamIcon